import {forwardRef} from 'react'
import {type TextProps} from 'react-native'
import Svg, {Path, type PathProps, type SvgProps} from 'react-native-svg'

import {CYBERDIONE_MOON_PATH} from '#/view/icons/cyberdioneMoon'
import {flatten, useTheme} from '#/alf'

type Props = {
  allowVariants?: boolean
  fill?: PathProps['fill']
  style?: TextProps['style']
} & Omit<SvgProps, 'style'>

/** The original Cyberdione circuit moon, combined into one SVG path. */
export function MoonPath({fill}: {fill: PathProps['fill']}) {
  return (
    <Path
      transform="matrix(1.46915,0,0,1.46915,-279.547,-189.521)"
      fill={fill}
      fillRule="nonzero"
      d={CYBERDIONE_MOON_PATH}
    />
  )
}

export const Logo = forwardRef(function LogoImpl(props: Props, ref) {
  const t = useTheme()
  const {allowVariants: _allowVariants, fill, ...rest} = props
  const styles = flatten(props.style)
  const size = parseInt(`${rest.width || 32}`, 10)
  return (
    <Svg
      // @ts-expect-error it's fiiiiine
      ref={ref}
      viewBox="0 0 1024 1024"
      {...rest}
      style={[{width: size, height: size}, styles]}>
      <MoonPath
        fill={
          fill === 'sky'
            ? t.palette.primary_500
            : fill || styles?.color || t.palette.primary_500
        }
      />
    </Svg>
  )
})
